export default __webpack_public_path__ + "media/images/small-info_v2-84b35bcfd837e07bfdb49a49c7cde5dd.png";